import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4df05f64"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "content" }
const _hoisted_2 = { class: "preview_box" }
const _hoisted_3 = { class: "preview_item" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text" }, "身份证人像面", -1))
const _hoisted_5 = { class: "preview_item" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text" }, "身份证国徽面", -1))
const _hoisted_7 = { class: "preview_item" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text" }, "手持身份证", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"height":"30px"} }, null, -1))
const _hoisted_10 = /*#__PURE__*/_createTextVNode("通过")
const _hoisted_11 = /*#__PURE__*/_createTextVNode("不通过")
const _hoisted_12 = { key: 0 }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"padding-bottom":"10px","font-weight":"700"} }, "请输入不通过的原因", -1))
const _hoisted_14 = { key: 1 }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"padding-bottom":"10px","font-weight":"700"} }, "确定审核通过吗？", -1))
const _hoisted_16 = [
  _hoisted_15
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_descriptions_item = _resolveComponent("a-descriptions-item")!
  const _component_a_image = _resolveComponent("a-image")!
  const _component_a_image_preview_group = _resolveComponent("a-image-preview-group")!
  const _component_a_descriptions = _resolveComponent("a-descriptions")!
  const _component_a_badge = _resolveComponent("a-badge")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_card = _resolveComponent("a-card")!
  const _component_a_textarea = _resolveComponent("a-textarea")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.detail)
      ? (_openBlock(), _createBlock(_component_a_card, { key: 0 }, {
          default: _withCtx(() => [
            _createVNode(_component_a_descriptions, {
              title: "实名认证信息",
              bordered: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_descriptions_item, { label: "姓名" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.detail?.name), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_descriptions_item, { label: "性别" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.detail?.sex === 0 ? '女' : _ctx.detail?.sex === 1 ? '男' : '保密'), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_descriptions_item, { label: "民族" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.detail?.nation) + "族", 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_descriptions_item, { label: "有效期限" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.dateFormat(_ctx.detail?.valid_time_start * 1000, false)) + "至" + _toDisplayString(_ctx.detail?.valid_time_end === '长期' ? '长期' : _ctx.dateFormat(_ctx.detail?.valid_time_end * 1000, false)), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_descriptions_item, { label: "签发机关" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.detail?.office), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_descriptions_item, { label: "提交时间" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.detail?.update_time), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_descriptions_item, {
                  label: "地址",
                  span: 3
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.detail?.address), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_descriptions_item, {
                  label: "图片",
                  span: 3
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_image_preview_group, null, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_2, [
                          _createElementVNode("div", _hoisted_3, [
                            _createVNode(_component_a_image, {
                              src: _ctx.detail?.card_image_just,
                              width: 150,
                              height: 150
                            }, null, 8, ["src"]),
                            _hoisted_4
                          ]),
                          _createElementVNode("div", _hoisted_5, [
                            _createVNode(_component_a_image, {
                              src: _ctx.detail?.card_image_back,
                              width: 150,
                              height: 150
                            }, null, 8, ["src"]),
                            _hoisted_6
                          ]),
                          _createElementVNode("div", _hoisted_7, [
                            _createVNode(_component_a_image, {
                              src: _ctx.detail?.card_image_hold,
                              width: 150,
                              height: 150
                            }, null, 8, ["src"]),
                            _hoisted_8
                          ])
                        ])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _hoisted_9,
            _createVNode(_component_a_descriptions, {
              title: "审核信息",
              bordered: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_descriptions_item, { label: "审核时间" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.detail?.review_time ? _ctx.dateFormat(_ctx.detail?.review_time * 1000) : '未审核'), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_descriptions_item, {
                  label: "审核结果",
                  span: 2
                }, {
                  default: _withCtx(() => [
                    (_ctx.detail?.status === 0)
                      ? (_openBlock(), _createBlock(_component_a_badge, {
                          key: 0,
                          status: "processing",
                          color: "red",
                          text: "审核中"
                        }))
                      : _createCommentVNode("", true),
                    (_ctx.detail?.status === 1)
                      ? (_openBlock(), _createBlock(_component_a_badge, {
                          key: 1,
                          color: "green",
                          text: "通过"
                        }))
                      : _createCommentVNode("", true),
                    (_ctx.detail?.status === 2)
                      ? (_openBlock(), _createBlock(_component_a_badge, {
                          key: 2,
                          color: "orange",
                          text: "未通过"
                        }))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_descriptions_item, {
                  label: "审核备注",
                  span: 3
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.detail?.remark || '无'), 1)
                  ]),
                  _: 1
                }),
                (_ctx.detail?.status === 0)
                  ? (_openBlock(), _createBlock(_component_a_descriptions_item, {
                      key: 0,
                      label: "审核操作",
                      span: 3
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_button, {
                          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.setVisible(true, true))),
                          style: {"margin-right":"16px"},
                          type: "primary"
                        }, {
                          default: _withCtx(() => [
                            _hoisted_10
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_a_button, {
                          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.setVisible(true, false)))
                        }, {
                          default: _withCtx(() => [
                            _hoisted_11
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    _createVNode(_component_a_modal, {
      visible: _ctx.visible,
      "onUpdate:visible": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.visible) = $event)),
      title: _ctx.pass ? '审核通过' : '审核不通过',
      onOk: _cache[4] || (_cache[4] = ($event: any) => (_ctx.onAudit(false))),
      confirmLoading: _ctx.loading
    }, {
      default: _withCtx(() => [
        (!_ctx.pass)
          ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
              _hoisted_13,
              _createVNode(_component_a_textarea, {
                value: _ctx.reason,
                "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.reason) = $event)),
                placeholder: "请输入不通过的原因",
                rows: 4
              }, null, 8, ["value"])
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_14, _hoisted_16))
      ]),
      _: 1
    }, 8, ["visible", "title", "confirmLoading"])
  ]))
}